export const base = (
    eventId = ':event'
) => `events/${eventId}/production-website`;
